import { createFileRoute, Outlet } from '@tanstack/react-router';
import { z } from 'zod';

const paramsSchema = z.object({
  strategyId: z.coerce.number().int().positive(),
});

export const Route = createFileRoute('/_authenticated/strategies/$strategyId')({
  params: {
    parse: (raw) => paramsSchema.parse(raw),
    stringify: ({ strategyId }) => ({ strategyId: String(strategyId) }),
  },
  component: StrategyLayoutRoute,
});

function StrategyLayoutRoute(): React.ReactElement {
  return <Outlet />;
}
